var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "conteneurLead", attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.cancelDialog()
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [
            _vm._v(
              _vm._s(_vm.$t("statSuperv24")) +
                " " +
                _vm._s(_vm.nameAgentComputed)
            )
          ]),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("statSuperv31")) +
                " " +
                _vm._s(_vm.dateStartComputed) +
                " " +
                _vm._s(_vm.$t("statSuperv32")) +
                " " +
                _vm._s(_vm.dateEndComputed) +
                " " +
                _vm._s(_vm.$t("statSuperv33")) +
                " "
            ),
            _c("strong", [_vm._v(_vm._s(_vm.afficheTotalTempsRef))])
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _vm.loading
                ? _c(
                    "v-card",
                    { staticClass: "mb-3", attrs: { height: "400px" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center pt-5" },
                        [
                          _c("v-progress-circular", {
                            staticClass: "primary--text",
                            attrs: { indeterminate: "" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              !_vm.loading
                ? _c(
                    "v-card",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { "d-flex": "", xs12: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-md-center",
                                  attrs: { xs12: "", md3: "" }
                                },
                                [
                                  _c("highcharts", {
                                    attrs: { options: _vm.productivityAgent }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("connectionRate")) +
                                        " : " +
                                        _vm._s(_vm.tauxProductivity1) +
                                        " % (" +
                                        _vm._s(_vm.afficheTotalTempsConnexion) +
                                        ")"
                                    )
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("agentsActivity")) +
                                        " : " +
                                        _vm._s(_vm.tauxProductivity2) +
                                        " % (" +
                                        _vm._s(_vm.afficheTotalTempsPresence) +
                                        ")"
                                    )
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("agentsInactivity")) +
                                        " : " +
                                        _vm._s(_vm.tauxProductivity3) +
                                        " % (" +
                                        _vm._s(_vm.afficheTotalTempsHorsProd) +
                                        ")"
                                    )
                                  ]),
                                  _c("br")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-md-center",
                                  attrs: { xs12: "", md3: "" }
                                },
                                [
                                  _c("highcharts", {
                                    attrs: { options: _vm.activityAgent }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("statSuperv28")) +
                                        " : " +
                                        _vm._s(_vm.afficheTotalTempsPresence)
                                    )
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("maximumOccupancy")) +
                                        " : " +
                                        _vm._s(_vm.afficheTotalTempsBusy)
                                    )
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("partialOccupation")) +
                                        " : " +
                                        _vm._s(
                                          _vm.afficheTotalTempsPartielleChat
                                        )
                                    )
                                  ]),
                                  _c("br")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-md-center",
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c("highcharts", {
                                    attrs: { options: _vm.tauxActivityAgent }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { "d-flex": "", xs12: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-md-center",
                                  attrs: { xs12: "", md4: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text-md-center" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("statSuperv34")) +
                                          " : " +
                                          _vm._s(_vm.afficheTotalTempsChat)
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-md-center",
                                  attrs: { xs12: "", md3: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text-md-center" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("statSuperv35")) +
                                          " : " +
                                          _vm._s(_vm.moyenChatMax)
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-md-center",
                                  attrs: { xs12: "", md3: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text-md-center" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("statSuperv36")) +
                                          " : " +
                                          _vm._s(
                                            _vm.afficheTotalTempsMoyenChats
                                          )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e75f107", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e75f107","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentsOccupationPeriode.vue
// module id = null
// module chunks = 